import { useMemo, type FC, type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      backgroundColor: theme.colors.surfaceContainerLow,
      gap: 16,
      paddingHorizontal: 16,
      flex: 1
    },
    list: { flex: 1 }
  });

type Props = { title: string; list: ReactNode };

export const ListScreenLayout: FC<Props> = ({ title, list }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <SafeAreaView style={styles.container} edges={{ bottom: 'maximum' }}>
      <Text variant="titleLarge">{title}</Text>
      <View style={styles.list}>{list}</View>
    </SafeAreaView>
  );
};
